// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes page-transition-slide-in {
  from {
    transform: translateX(7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-reverse-slide-in {
  from {
    transform: translateX(-7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-slide-out {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-7.5rem);
  }
}
@keyframes width-grow {
  from {
    transform: scaleX(0.001);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes width-shrink {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0.001);
  }
}
@keyframes height-grow {
  from {
    transform: scaleY(0.0001);
  }
  to {
    transform: scaleY(1);
  }
}
@keyframes height-fade-and-grow {
  from {
    opacity: 0;
    transform: scaleY(0.0001);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes height-shrink {
  from {
    transform: scaleY(1);
  }
  to {
    transform: scaleY(0.001);
  }
}
@keyframes roll-in {
  from {
    opacity: 0;
    transform: translateX(10rem) rotate(500deg);
  }
  to {
    opacity: 1;
    transform: translateX(0) rotate(0);
  }
}
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateX(5rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slide-out {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-5rem);
  }
}
@keyframes drop {
  0% {
    transform: translateY(-1rem);
  }
  100% {
    transform: translateY(0);
  }
}
app-root button.message-modal-open {
  position: fixed;
  bottom: calc(calc(1.5rem + 47px) + 0.75rem);
  left: 50%;
  transform: translateX(-50%);
}
app-root button.message-modal-open.hidden:not(:focus) {
  display: none;
  visibility: hidden;
}
app-root .messaging-dialog {
  width: calc(100% - 32px);
  max-width: 25rem;
  min-width: 320px;
  max-height: 100%;
  z-index: 50;
  overflow-y: auto;
  padding-bottom: 2rem;
  background: none;
  text-align: center;
}
app-root .messaging-dialog * {
  text-align: center;
}
app-root .messaging-dialog .process-explainer footer a:focus {
  outline: solid 1px #a8a8a8;
}
app-root .messaging-dialog .process-explainer footer a:focus:not(:focus-visible) {
  outline: none;
}
app-root .messaging-dialog button.modal-close {
  z-index: 51;
  position: relative;
  transform: translateY(-50%);
  transform-origin: center;
}
app-root .messaging-dialog button.modal-close:active {
  transform: scale(0.95) translateY(-50%);
}
@media (max-height: 450px) {
  app-root .messaging-dialog button.modal-close {
    position: fixed;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    transform-origin: left;
  }
  app-root .messaging-dialog button.modal-close:active {
    transform: scale(0.95) translateX(-50%);
  }
}
app-root button.modal-close,
app-root button.message-modal-open {
  background-color: #1f1f1f;
  border: none;
  border-radius: 1.125rem;
  outline-color: #6c6c6c;
  color: white;
  padding: 7px 24px;
  transform-origin: left;
  min-width: max-content;
}
app-root button.modal-close:active,
app-root button.message-modal-open:active {
  transform: scale(0.95) translateX(-50%);
}
app-root button.modal-close:hover,
app-root button.message-modal-open:hover {
  background-color: #3e3e3e;
}
app-root button.modal-close:focus:not(:focus-visible),
app-root button.message-modal-open:focus:not(:focus-visible) {
  outline: none;
}
app-root button.modal-close svg,
app-root button.message-modal-open svg {
  width: 1em;
  height: auto;
  vertical-align: middle;
  margin-left: 0.5em;
}
app-root button.modal-close svg.close-icon,
app-root button.message-modal-open svg.close-icon {
  width: 0.75em;
  vertical-align: baseline;
}
@media (min-width: 1151px) {
  app-root .messaging-dialog:not([open]),
  app-root button.message-modal-open {
    display: none;
    visibility: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Components/Brand/Messaging/LeadFeed/Modal/Modal.less","webpack://./src/Styles/animations.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;ACPE;EACE;IACE,UAAA;EDSJ;ECNE;IACE,UAAA;EDQJ;AACF;ACLE;EACE;IACE,UAAA;EDOJ;ECJE;IACE,UAAA;EDMJ;AACF;ACHE;EACE;IACE,6BAAA;EDKJ;ECFE;IACE,wBAAA;EDIJ;AACF;ACDE;EACE;IACE,8BAAA;EDGJ;ECAE;IACE,wBAAA;EDEJ;AACF;ACCE;EACE;IACE,wBAAA;EDCJ;ECEE;IACE,8BAAA;EDAJ;AACF;ACGE;EACE;IACE,wBAAA;EDDJ;ECIE;IACE,oBAAA;EDFJ;AACF;ACKE;EACE;IACE,oBAAA;EDHJ;ECME;IACE,wBAAA;EDJJ;AACF;ACOE;EACE;IACE,yBAAA;EDLJ;ECQE;IACE,oBAAA;EDNJ;AACF;ACSE;EACE;IACE,UAAA;IACA,yBAAA;EDPJ;ECUE;IACE,UAAA;IACA,oBAAA;EDRJ;AACF;ACWE;EACE;IACE,oBAAA;EDTJ;ECYE;IACE,wBAAA;EDVJ;AACF;ACaE;EACE;IACE,UAAA;IACA,2CAAA;EDXJ;ECaE;IACE,UAAA;IACA,kCAAA;EDXJ;AACF;ACcE;EACE;IACE,UAAA;IACA,2BAAA;EDZJ;ECcE;IACE,UAAA;IACA,wBAAA;EDZJ;AACF;ACeE;EACE;IACE,UAAA;IACA,2BAAA;EDbJ;ECeE;IACE,UAAA;IACA,wBAAA;EDbJ;AACF;ACgBE;EACE;IACE,UAAA;IACA,wBAAA;EDdJ;ECgBE;IACE,UAAA;IACA,4BAAA;EDdJ;AACF;ACiBE;EACE;IACE,4BAAA;EDfJ;ECkBE;IACE,wBAAA;EDhBJ;AACF;AArIA;EAEI,eAAA;EACA,2CAAA;EACA,SAAA;EACA,2BAAA;AAsIJ;AApII;EACE,aAAA;EACA,kBAAA;AAsIN;AA/IA;EAcI,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EAEA,oBAAA;EACA,gBAAA;EACA,kBAAA;AAmIJ;AA1JA;EAyBM,kBAAA;AAoIN;AA7JA;EA6BM,0BAAA;AAmIN;AAlIM;EACE,aAAA;AAoIR;AAnKA;EAoCM,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,wBAAA;AAkIN;AAjIM;EACE,uCAAA;AAmIR;AAjIM;EAAA;IACE,eAAA;IACA,YAAA;IACA,SAAA;IACA,2BAAA;IACA,sBAAA;EAoIN;EAnIM;IACE,uCAAA;EAqIR;AACF;AAxLA;;EA0DI,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;AAkIJ;AAhII;;EACE,uCAAA;AAmIN;AAhII;;EACE,yBAAA;AAmIN;AAhII;;EACE,aAAA;AAmIN;AA/MA;;EAgFM,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAmIN;AAlIM;;EACE,aAAA;EACA,wBAAA;AAqIR;AAhIE;EAAA;;IAGI,aAAA;IACA,kBAAA;EAkIJ;AACF","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../../../../Styles/mediaQueries.less';\n@import '../../../../../Styles/colours.less';\n@import '../../../../../Styles/utilities.less';\n@import '../../../../Brand/ProcessOverview/LeadFeed/ProcessOverviewAnimation.less';\n\napp-root {\n  button.message-modal-open {\n    position: fixed;\n    bottom: calc(@nav-height + 0.75rem);\n    left: 50%;\n    transform: translateX(-50%);\n\n    &.hidden:not(:focus) {\n      display: none;\n      visibility: hidden;\n    }\n  }\n  .messaging-dialog {\n    @combined-gutter: @body-gutter-width * 2;\n    width: calc(100% - @combined-gutter);\n    max-width: 25rem;\n    min-width: 320px;\n    max-height: 100%;\n    z-index: 50;\n    overflow-y: auto;\n\n    padding-bottom: 2rem;\n    background: none;\n    text-align: center;\n    * {\n      text-align: center;\n    }\n\n    .process-explainer footer a:focus {\n      outline: solid 1px @faint-outline-grey;\n      &:not(:focus-visible) {\n        outline: none;\n      }\n    }\n\n    button.modal-close {\n      z-index: 51;\n      position: relative;\n      transform: translateY(-50%);\n      transform-origin: center;\n      &:active {\n        transform: scale(0.95) translateY(-50%);\n      }\n      @media (max-height: 450px) {\n        position: fixed;\n        bottom: 16px;\n        left: 50%;\n        transform: translateX(-50%);\n        transform-origin: left;\n        &:active {\n          transform: scale(0.95) translateX(-50%);\n        }\n      }\n    }\n  }\n\n  button.modal-close,\n  button.message-modal-open {\n    background-color: @text-black;\n    border: none;\n    border-radius: 1.125rem;\n    outline-color: @outline-grey;\n    color: white;\n    padding: 7px 24px;\n    transform-origin: left;\n    min-width: max-content;\n\n    &:active {\n      transform: scale(0.95) translateX(-50%);\n    }\n\n    &:hover {\n      background-color: @hover-grey;\n    }\n\n    &:focus:not(:focus-visible) {\n      outline: none;\n    }\n\n    svg {\n      width: 1em;\n      height: auto;\n      vertical-align: middle;\n      margin-left: 0.5em;\n      &.close-icon {\n        width: 0.75em;\n        vertical-align: baseline;\n      }\n    }\n  }\n\n  @media @desktopUp {\n    .messaging-dialog:not([open]),\n    button.message-modal-open {\n      display: none;\n      visibility: hidden;\n    }\n  }\n}\n","app-root {\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fade-out {\n    from {\n      opacity: 1;\n    }\n\n    to {\n      opacity: 0;\n    }\n  }\n\n  @keyframes page-transition-slide-in {\n    from {\n      transform: translateX(7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-reverse-slide-in {\n    from {\n      transform: translateX(-7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-slide-out {\n    from {\n      transform: translateX(0);\n    }\n\n    to {\n      transform: translateX(-7.5rem);\n    }\n  }\n\n  @keyframes width-grow {\n    from {\n      transform: scaleX(0.001);\n    }\n\n    to {\n      transform: scaleX(1);\n    }\n  }\n\n  @keyframes width-shrink {\n    from {\n      transform: scaleX(1);\n    }\n\n    to {\n      transform: scaleX(0.001);\n    }\n  }\n\n  @keyframes height-grow {\n    from {\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-fade-and-grow {\n    from {\n      opacity: 0;\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      opacity: 1;\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-shrink {\n    from {\n      transform: scaleY(1);\n    }\n\n    to {\n      transform: scaleY(0.001);\n    }\n  }\n\n  @keyframes roll-in {\n    from {\n      opacity: 0;\n      transform: translateX(10rem) rotate(500deg);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0) rotate(0);\n    }\n  }\n\n  @keyframes slide-up {\n    from {\n      opacity: 0;\n      transform: translateY(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slide-in {\n    from {\n      opacity: 0;\n      transform: translateX(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slide-out {\n    from {\n      opacity: 1;\n      transform: translateX(0);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(-5rem);\n    }\n  }\n\n  @keyframes drop {\n    0% {\n      transform: translateY(-1rem);\n    }\n\n    100% {\n      transform: translateY(0);\n    }\n  }\n}\n\n.cubic-slide-in-animation(@delay: 0s) {\n  animation: 0.25s ease-in normal backwards @delay fade-in,\n    0.3s cubic-bezier(0.39, 0.67, 0.61, 0.96) normal backwards @delay page-transition-slide-in;\n}\n.cubic-reverse-slide-in-animation(@delay: 0s) {\n  animation: 0.4s ease-in normal backwards @delay fade-in,\n    0.2s cubic-bezier(0.23, 0.06, 0.55, 0.42) normal backwards @delay\n      page-transition-reverse-slide-in;\n}\n.cubic-slide-out-animation(@delay: 0s) {\n  animation: 0.3s ease-in @delay forwards fade-out,\n    0.3s cubic-bezier(0.23, 0.06, 0.55, 0.42) @delay forwards page-transition-slide-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
